import * as React from "react";
import { ScrollView } from "react-native";

import { Move } from "../../types";
import { Info, Space, JustifyContent } from "../../styled-component";

import Layout from "../common/Layout";
import List from "../common/List";
import Text from "../common/Text";
import Button from "../common/PressableButton";

import MoveOne from "./MoveOne";
import useListMoves from "../../hooks/moves/useListMoves";
import Card from "../common/Card";

const minWidthStyle = {
  minWidth: "100%",
};

export interface VideoInputProps {
  value?: Move["id"];
  onChange: (value?: Move["id"]) => void;
  showMove?: (move: Move) => boolean;
}

function MoveInput({ value, onChange, showMove }: VideoInputProps) {
  const movesQuery = useListMoves();

  return (
    <ScrollView horizontal contentContainerStyle={minWidthStyle}>
      <Info style={minWidthStyle}>
        <Layout.Column>
          <Space />

          <Layout.Row justifyContent={JustifyContent.Center}>
            <List.Async<Move>
              {...movesQuery}
              isEmpty={(moves) =>
                !moves.filter((move) => !showMove || showMove(move)).length
              }
              renderEmpty={() => (
                <Layout.Row>
                  <Space />

                  <Text>No Moves</Text>

                  <Space />
                </Layout.Row>
              )}
              renderItem={({ item }: { item: Move; index: number }) => (
                <>
                  {(!value || value === item.id) &&
                    (!showMove || showMove(item)) && (
                      <>
                        <Space />

                        <Card>
                          <Button
                            onPress={() =>
                              onChange?.(!value ? item.id : undefined)
                            }
                            selected={item.id === value}
                          >
                            <Layout.Box size={1}>
                              <MoveOne move={item} />
                            </Layout.Box>
                          </Button>
                        </Card>
                      </>
                    )}
                </>
              )}
            />

            <Space />
          </Layout.Row>

          <Space />
        </Layout.Column>
      </Info>
    </ScrollView>
  );
}

export default MoveInput;
